import {
  FormControl,
  MenuItem,
  Select,
  Switch,
  TableCell,
  TableRow,
} from '@mui/material';
import { memo, useEffect, useState } from 'react';

const TableRowItem = ({ item, setRoleHandler, rolesList }) => {
  const [role, setRole] = useState(() => {
    return rolesList.find((role) => role.id === item.role)?.id;
  });

  useEffect(() => {
    const itemRole = rolesList.find((role) => role.id === item.role)?.id;
    setRole(itemRole);
  }, [item.role, rolesList]);

  const handleChange = (event) => {
    setRole(event.target.value);
    setRoleHandler(item.id, event.target.value);
  };

  return (
    <TableRow>
      <TableCell sx={{ width: '300px' }}>{item.name}</TableCell>
      <TableCell>{item.rank}</TableCell>
      <TableCell>
        <FormControl
          sx={{ m: 1, ml: 0, minWidth: 120, width: 200 }}
          size="small"
        >
          <Select id="Period-selection" value={role} onChange={handleChange}>
            {rolesList?.map((item) => (
              <MenuItem key={item.id} value={item.id}>
                {item.name === 'Admin' ? 'Assigner' : item.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </TableCell>
    </TableRow>
  );
};

export default memo(TableRowItem);
